export enum CostCenterViewTabsEnum {
  ALL = 'all',
  REVENUE = 'revenue',
  EXPENSES = 'expenses',
}
